/* eslint-disable react/style-prop-object */
import React, { useContext, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { filtrationcontext } from "../../../context/Filtercontext";
import trans from "../../../utils";
import Searchbar from "../../Helpers/Searchbar/Searchbar";
import { InputSelect } from "../../Helpers/Input/RefactoredInput";
import { useGetIRenumsQuery } from "../../../Redux/service/IR/IR";

export default function InspectionRequestHead({ setFilter }) {
	const { setSearchQuery } = useContext(filtrationcontext);
	const userInfo = useSelector((state) => state.users.user);

	const [query, setQuery] = useState("");
	const handleSearch = (e) => {
		setQuery(e.target.value);
		setSearchQuery(e.target.value);
	};
	const { data: enums } = useGetIRenumsQuery();
	
	const { requestStatus } = useMemo(() => {
		if (!enums?.data) return { requestStatus: [] };

		const { requestStatus } = enums.data;
		const userRole = userInfo?.attributes?.role?.toLowerCase();
		
		// Filter out QA_REJECTED for consultants
		const filteredStatuses = userRole === 'consultant' 
			? requestStatus.filter(status => status !== 'QA_REJECTED')
			: requestStatus;
		
		// Since requestStatus is an array, map it directly
		const statusOptions = filteredStatuses.map((status) => ({
			label: trans(status),
			value: status, // Now this will be "DRAFT", "PENDING_QA", "QA_REJECTED", etc.
		}));

		return {
			requestStatus: statusOptions,
		};
	}, [enums, userInfo]);

	return (
		<>
			<div className="bg-white p-16 d-flex align-items-baseline gap-3">
				<Searchbar
					style="search search-dark input-group"
					path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
					placeholder={trans("Search")}
					value={query}
					onChange={handleSearch}
				/>

				<InputSelect
					placeholder={trans("status")}
					options={requestStatus}
					formstyle="w-25 text-capitalize"
					onChange={(selectedValue) => {
						setFilter((prev) => ({ ...prev, status: selectedValue }));
					}}
				/>
			</div>
		</>
	);
}